/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { RefObject } from 'react'
import { FormikProps } from 'formik'
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Button, Card, Form as NXUIForm, Theme } from '@nexigendigital/nxui'
import { useUpdateCartItemsMutation } from 'api/shop'
import { Weight } from 'models/enums'
import { useAppSelector } from 'store/hooks'

import PaymentList from 'containers/shop/checkout/paymentList'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    paymentMethodRef: RefObject<FormikProps<{ card: string | null }>>,
    handleSubmit: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function CreditCardList({ paymentMethodRef, handleSubmit }: Props) {
    const { cart, paymentMethod } = useAppSelector((state) => state.shop)
    const [updateCartItems] = useUpdateCartItemsMutation()

    if (!cart) {
        return null
    }

    return (
        <CreditCardListWrapper
            footer={
                <>
                    <Button disabled={!paymentMethod} type={'button'} color={'primary'} onClick={() => handleSubmit()}>
                        Checkout
                    </Button>
                    <AccountCredit>
                        <div>Account Credit</div>
                        <NXUIForm.Switch
                            checked={cart.account_credit > 0}
                            onClick={() => updateCartItems({ uuid: cart.uuid, account_credit: cart.account_credit })}
                        />
                        <div>{cart.account_credit}</div>
                    </AccountCredit>
                </>
            }
        >
            <PaymentList paymentMethodRef={paymentMethodRef}/>
        </CreditCardListWrapper>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const CreditCardListWrapper = styled(Card)`
    width: 100%;
`

const AccountCredit = styled.div`
    font-size: 0.875rem;
    ${Theme.Functions.setFont('Inter', Weight.Medium)};
    color: ${props => props.theme['text--100']};
    display: flex;
    gap: 5px;
`
